var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.14 21.18-8.3 8.3-4.98-4.98",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M38.7 12.34a22.54 22.54 0 0 1-12.93-5.37 1.98 1.98 0 0 0-2.54 0 22.64 22.64 0 0 1-12.93 5.37c-1.02.08-1.8.96-1.8 1.98v8.66c0 8.74 6.31 16.93 14.96 19.37.67.2 1.4.2 2.09 0 8.64-2.44 14.95-10.63 14.95-19.36v-8.66c0-1.03-.78-1.9-1.8-1.99Z",
    stroke: "#3C00FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.3b99ab14455f2d8efd14e1b8b23f853d.svg";
export { ForwardRef as ReactComponent };